import type { GridValidRowModel } from '@mui/x-data-grid-premium';
import type { GridColValue } from 'src/modules/grids/DataGrid';

/** ONE per-row editability rule for keyboard nav + click gating (was copy-pasted in 4 hooks). */
export const isColumnEditableForRow = (colDef: GridColValue, row: GridValidRowModel): boolean =>
  colDef.isCellEditable?.(row) !== false;
